import { render, staticRenderFns } from "./delivery-navi.vue?vue&type=template&id=97ac0cc6&scoped=true&"
import script from "./delivery-navi.vue?vue&type=script&lang=js&"
export * from "./delivery-navi.vue?vue&type=script&lang=js&"
import style0 from "./delivery-navi.vue?vue&type=style&index=0&id=97ac0cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ac0cc6",
  null
  
)

export default component.exports